import { render } from "./StudentLease.vue?vue&type=template&id=3ed1d378&scoped=true"
import script from "./StudentLease.vue?vue&type=script&lang=js"
export * from "./StudentLease.vue?vue&type=script&lang=js"

import "./StudentLease.vue?vue&type=style&index=0&id=3ed1d378&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed1d378"]])

export default __exports__